import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-policies-procedures',
    template: '<router-outlet></router-outlet>',
})
export class PoliciesProceduresComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
